import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ViaCepService } from '../../../../core/services/address/via-cep/via-cep.service'
import { AddressService } from '../../../../core/services/address/address/address.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'

@Component({
  selector: 'address-client-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    MatSlideToggle,
  ],
  templateUrl: './address-client-edit-form.component.html',
  styleUrl: './address-client-edit-form.component.scss',
  providers: [AddressTypeService, AddressService, ViaCepService],
  standalone: true,
})
export class AddressClientEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private addressTypeService: AddressTypeService,
    private addressService: AddressService,
    private viaCepService: ViaCepService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() personId = 0

  listType: any[] = []

  ngOnInit(): void {
    this.listTypeAddress()
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  listTypeAddress() {
    this.addressTypeService.listAddressType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getAddressByPostalCode() {
    const postalCode = this.form.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.edit) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('addressType')?.setValue(this.editItem.data.tipoEnderecoId)
    this.form.get('postalCode')?.setValue(this.editItem.data.cep)
    this.form.get('street')?.setValue(this.editItem.data.logradouro)
    this.form.get('number')?.setValue(this.editItem.data.numero)
    this.form.get('complement')?.setValue(this.editItem.data.complemento)
    this.form.get('neighborhood')?.setValue(this.editItem.data.bairro)
    this.form.get('city')?.setValue(this.editItem.data.cidade)
    this.form.get('country')?.setValue(this.editItem.data.pais)
    this.form.get('state')?.setValue(this.editItem.data.estado)
    this.form.get('latitude')?.setValue(this.editItem.data.latitude)
    this.form.get('longitude')?.setValue(this.editItem.data.longitude)
    this.form
      .get('active')
      ?.setValue(this.editItem.data.ativo == 'Ativo' ? true : false)
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.form.get('street')?.setValue('')
      this.form.get('number')?.setValue('')
      this.form.get('complement')?.setValue('')
      this.form.get('neighborhood')?.setValue('')
      this.form.get('city')?.setValue('')
      this.form.get('state')?.setValue('')
      this.form.get('country')?.setValue('')
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('number')?.setValue('')
      this.form.get('complement')?.setValue(element.complemento)
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
      this.form.get('country')?.setValue('Brasil')
    }
  }

  resetForm() {
    this.form.reset()
    this.form.get('active')?.setValue(true)
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      addressType: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      street: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      complement: [''],
      number: ['', [Validators.required]],
      country: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      latitude: [''],
      longitude: [''],
      active: [true],
    })
  }

  createAddress() {
    this.loading = true
    const model = this.createModel()
    this.addressService.createAddress(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  editAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.addressService.editAddress(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  cancel() {
    this.response.emit({ refresh: false, clear: true })
    this.resetForm()
  }

  createModel(edit = false) {
    if (edit) {
      return {
        id: this.editItem.data.id,
        pessoaId: this.personId,
        tipoEnderecoId: this.form.controls['addressType'].value,
        cep: this.form.controls['postalCode'].value,
        logradouro: this.form.controls['street'].value,
        numero: this.form.controls['number'].value,
        complemento: this.form.controls['complement'].value,
        bairro: this.form.controls['neighborhood'].value,
        estado: this.form.controls['state'].value,
        cidade: this.form.controls['city'].value,
        pais: this.form.controls['country'].value,
        latitude: this.form.controls['latitude'].value,
        longitude: this.form.controls['longitude'].value,
        ativo: this.form.controls['active'].value ? 'S' : 'N',
      }
    } else {
      return {
        pessoaId: this.personId,
        tipoEnderecoId: this.form.controls['addressType'].value,
        cep: this.form.controls['postalCode'].value,
        logradouro: this.form.controls['street'].value,
        numero: this.form.controls['number'].value,
        complemento: this.form.controls['complement'].value,
        bairro: this.form.controls['neighborhood'].value,
        estado: this.form.controls['state'].value,
        cidade: this.form.controls['city'].value,
        pais: this.form.controls['country'].value,
        latitude: this.form.controls['latitude'].value,
        longitude: this.form.controls['longitude'].value,
        ativo: this.form.controls['active'].value ? 'S' : 'N',
      }
    }
  }
}
